import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './FreelanceInterviewAppreciationForm.jsx'

export default createSubmit(name)
